module.exports = __webpack_public_path__ + "static/media/Hebrew_Public.fd7beac3.svg";